import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { useAnalyticsProvider } from "@oss/components";

const toggleWidth = 42;
const iconSize = 16;

const styles = theme => {
  const commonPseudoElementStyles = {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    lineHeight: 0,
    color: "white",
    display: "none"
  };

  return {
    root: {
      display: "inline-flex",
      width: toggleWidth,
      position: "relative",
      flexShrink: 0,
      zIndex: 0, // Reset the stacking context.
      // For correct alignment with the text.
      verticalAlign: "middle",
      alignItems: "center",
      justifyContent: "center"
    },
    bar: {
      backgroundColor: "#B2B2B3",
      borderRadius: 7,
      display: "block",
      height: 11,
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      transition: theme.transitions.create("background-color", {
        duration: theme.transitions.duration.shortest
      }),
      width: "100%",
      zIndex: -1
    },
    barPositive: {
      backgroundColor: theme.palette.black,
      "&:before": {
        ...commonPseudoElementStyles,
        fontSize: theme.typography.pxToRem(11),
        content: "'+'",
        left: "41%",
        top: "50%"
      }
    },
    barNeutral: {
      backgroundColor: "#e5e5e5"
    },
    barNegative: {
      backgroundColor: theme.palette.primary.main,
      "&:before": {
        ...commonPseudoElementStyles,
        content: "'–'",
        fontSize: theme.typography.pxToRem(12),
        right: "26%",
        top: "49%"
      }
    },
    icon: {
      display: "inline-block",
      boxShadow: theme.shadows[1],
      backgroundColor: theme.palette.secondary.light,
      width: iconSize,
      height: iconSize,
      borderRadius: "50%",
      transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest
      }),
      position: "absolute",
      top: "50%",
      transform: `translate(0, -52%)`
    },
    iconPositive: {
      transform: `translate(${Math.ceil((toggleWidth - iconSize) / 2)}px, -52%)`
    },
    iconNeutral: { transform: `translate(0, -52%)` },
    iconNegative: {
      transform: `translate(${-Math.ceil(
        (toggleWidth - iconSize) / 2
      )}px, -52%)`
    },
    touchTargets: {
      position: "absolute",
      width: "100%",
      top: "50%",
      transform: "translateY(-50%)",
      left: 0,
      height: iconSize,
      opacity: 0,
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)"
    }
  };
};

const OSSTriStateToggle = ({
  classes,
  className,
  state = 1,
  onChange = () => {},
  label = ""
}) => {
  const [toggleState, setToggleState] = useState(state);
  const setTrackerData = useAnalyticsProvider();

  const iconToggleStateClasses = [
    classes.iconNegative,
    classes.iconNeutral,
    classes.iconPositive
  ];

  const barToggleStateClasses = [
    classes.barNegative,
    classes.barNeutral,
    classes.barPositive
  ];

  useEffect(() => {
    setToggleState(state);
  }, [state]);

  return (
    <span className={[classes.root, className].join(" ")}>
      <span className={classes.touchTargets}>
        <span
          data-testid="tri-toggle-negative"
          onClick={() => setToggleState(0)}
        ></span>
        <span
          data-testid="tri-toggle-neutral"
          onClick={() => setToggleState(1)}
        ></span>
        <span
          data-testid="tri-toggle-positive"
          onClick={() => setToggleState(2)}
        ></span>
      </span>
      <span
        onTransitionEnd={() => {
          let toggle = "";
          switch (toggleState) {
            case 0:
              toggle = "exclude";
              break;
            case 1:
              toggle = "neutral";
              break;
            case 2:
              toggle = "include";
              break;
            default:
              break;
          }
          setTrackerData({
            method: "event",
            category: "Profiles List",
            action: "Tri-toggle click",
            label: `${label}: ${toggle}`
          });
          onChange(toggleState);
        }}
        className={[classes.icon, iconToggleStateClasses[toggleState]].join(
          " "
        )}
      ></span>
      <span
        className={[classes.bar, barToggleStateClasses[toggleState]].join(" ")}
      />
    </span>
  );
};

export default withStyles(styles)(OSSTriStateToggle);
